import { createFileRoute } from "@tanstack/react-router";
import { filterParam, textParam } from "@/utils/searchParams";

// The trail's filters live in the URL, so leaving the page and coming back
// keeps the slice an admin was reading (NAV-45).
//
// Both dropdowns are data rather than fixed lists: their options are the
// actions and entity types present in the logs that loaded, which grow as the
// app does. A value none of them holds is shown as selected over an empty
// table rather than validated away — see FilterSelect.
export type AuditLogsSearch = {
  q?: string;
  action?: string;
  entity?: string;
};

export const Route = createFileRoute("/admin/audit-logs")({
  validateSearch: (search: Record<string, unknown>): AuditLogsSearch => ({
    q: textParam(search.q),
    action: filterParam(search.action),
    entity: filterParam(search.entity),
  }),
});
